export const RECOGNITION_DEFINITION_KIND = 'recognition-definition';

export function isIssuedRecognition(record) {
  return record?.recordKind !== RECOGNITION_DEFINITION_KIND
    && typeof record?.studentId === 'string' && record.studentId.trim().length > 0;
}

/** Legacy definitions also have issuedAt; the subject fields are decisive. */
export function isRecognitionDefinition(record) {
  if (!record || typeof record !== 'object' || Array.isArray(record)) return false;
  const own = key => Object.prototype.hasOwnProperty.call(record, key);
  if (['studentId', 'studentIds', 'studentName', 'learnerId', 'learnerIds', 'learnerName',
    'issuedById', 'issuedByName', 'phaseContext', 'phaseContextSource'].some(own)) return false;
  if (own('recordKind') && record.recordKind !== RECOGNITION_DEFINITION_KIND) return false;
  if (own('domainId') && record.domainId !== 'recognition') return false;
  if (own('mode') && record.mode !== 'recognition') return false;
  return typeof record.name === 'string' && record.name.trim().length > 0
    && (Array.isArray(record.levels) || typeof record.level === 'number');
}
